import React from 'react';

const ActionToolbar = ({
  lines,
  selectAllLines,
  autoSaveEnabled,
  setAutoSaveEnabled,
  label = 'Select All'
}) => {
  return (
    <nav className="header-actions" aria-label="Quote actions">
      <button
        onClick={selectAllLines}
        disabled={!lines.length}
        aria-describedby="select-all-desc"
      >
        {label} ({lines.filter(l => l.state !== 'completed').length})
      </button>
      <div id="select-all-desc" className="sr-only">
        {label === 'Select Page' ? 'Select all incomplete lines on this page for bulk operations' : 'Select all incomplete quote lines for bulk operations'}
      </div>

      <button
        onClick={() => setAutoSaveEnabled(!autoSaveEnabled)}
        aria-pressed={autoSaveEnabled}
        aria-describedby="autosave-desc"
      >
        Auto-save: {autoSaveEnabled ? 'ON' : 'OFF'}
      </button>
      <div id="autosave-desc" className="sr-only">
        Toggle automatic saving of changes after 2 seconds
      </div>

      <div className="keyboard-hint" role="note" aria-label="Keyboard shortcuts">
        Click or press Enter to edit • Tab to navigate • Ctrl+C to copy • Ctrl+V to paste • Esc to cancel
      </div>
    </nav>
  );
};

export default ActionToolbar;